module.exports = __webpack_public_path__ + "img/icon-06.da3c7488.png";